module.exports = __webpack_public_path__ + "static/media/ic-send-cover.8a20bf72.svg";